import { render, staticRenderFns } from "./alerts2.vue?vue&type=template&id=75300884&"
import script from "./alerts2.vue?vue&type=script&lang=js&"
export * from "./alerts2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports